/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext } from "react";
import "./style.scss";
import Icon from "react-icons-kit";
import { settings } from "react-icons-kit/feather";
import { FaImage, FaPlus } from "react-icons/fa";

import Gallery from "../../../components/MyPhoto/Gallery/Index";
import SettingsModal from "../../../components/MyPhoto/Modal/Settings";
import ImageCrop from "../../../components/Form/UploadImage";
import { Images } from "../../../utils/Images";
import { UserContext } from "../../../utils/context/userContext";
import Loading from "../../../components/Loading/Index";

const Index = () => {
  const [setting, setSetting] = useState({ show: false, loading: false });
  const [modal, setModal] = useState({ show: false, loading: false });

  const { user } = useContext(UserContext);

  if (!user) return <Loading />;

  // ✅ Filter images
  const clearImages =
    user?.uploadImages?.filter((item) =>
      item.name?.toLowerCase().includes("clear")
    ) || [];

  const totalSlots = 6;

  return (
    <div className="photo-container">
      <div className="flex-fill p-4">

        {/* Header */}
        <div className="d-flex justify-content-between mb-4">
          <div>
            <h3 className="fw-bold">Photo Gallery</h3>
            <small className="text-muted">
              Manage your profile visibility and photos
            </small>
          </div>

          <button
            type="button"
            className="btn shadow rounded-circle"
            style={{ height: "42px" }}
            onClick={() => setSetting({ ...setting, show: true })}
          >
            <Icon icon={settings} size={22} />
          </button>
        </div>

        <div className="row g-4">

          {/* LEFT */}
          <div className="col-lg-9">

            {/* Upload Box */}
            <div className="upload-box text-center mb-4">
              <div className="icon-circle mb-3">
                <FaImage />
              </div>

              <h5 className="fw-bold">Upload your photos</h5>
              <p className="text-muted">
                High quality photos increase your match probability by up to 3x.
              </p>

              <button
                className="btn btn-success px-4"
                onClick={() => setModal({ ...modal, show: true })}
              >
                Browse Photo
              </button>
            </div>

            {/* Uploaded Photos */}
            <h5 className="fw-bold mb-3">
              Uploaded Photos ({clearImages.length}/6)
            </h5>

            <div className="row g-3">

              {/* ✅ Always 6 slots */}
              {[...Array(totalSlots)].map((_, i) => {
                const item = clearImages[i];

                return (
                  <div key={i} className="col-12 col-sm-6 col-md-4 col-lg-4">
                    {item ? (
                      <Gallery item={item} />
                    ) : (
                      <div
                        className="empty-box"
                        onClick={() =>
                          setModal({ ...modal, show: true })
                        }
                      >
                        <FaPlus />
                        <small>ADD PHOTO</small>
                      </div>
                    )}
                  </div>
                );
              })}

            </div>
          </div>

          {/* RIGHT */}
          <div className="col-lg-3">

            {/* Guidelines */}
            <div className="card p-3 mb-3 border-0">
              <h6 className="fw-bold">Photo Guidelines</h6>

              <p className="text-success">✔ Preferred Photos</p>
              <div className="d-flex gap-2 mb-3">
                <div className="guide-img">
                  <img src={Images.Close} className="singleImage" alt="close" />
                </div>
                <div className="guide-img">
                  <img src={Images.Clear} className="singleImage" alt="full" />
                </div>
                <div className="guide-img">
                  <img src={Images.Clear2} className="singleImage" alt="clear" />
                </div>
              </div>

              <p className="text-danger">✖ Avoid These</p>
              <div className="d-flex gap-2 mb-3">
                <div className="guide-img grayscale">
                  <img src={Images.Blur} className="singleImage" alt="blur" />
                </div>
                <div className="guide-img grayscale">
                  <img src={Images.Group} className="singleImage" alt="group" />
                </div>
                <div className="guide-img grayscale">
                  <img src={Images.Side} className="singleImage" alt="side" />
                </div>
              </div>

              <hr />

              <h6 className="fw-bold">Notes & Tips</h6>
              <ul className="small text-muted">
                <li>Smile. Friendly faces get more matches.</li>
                <li>Add clear recent photos</li>
                <li>Upload up to 6 photos</li>
              </ul>

              <p className="text-danger small">
                Cigarette, watermark, side-face photos rejected.
              </p>
            </div>

            {/* Help */}
            <div className="help-card p-3">
              <h6 className="fw-bold">Need Help?</h6>
              <p className="small">
                Our support team is here to help you
              </p>
              <a href="/my-dashbord/contact" className="text-success fw-bold">
                Contact →
              </a>
            </div>

          </div>
        </div>
      </div>

      {/* Settings Modal */}
      {setting.show && (
        <SettingsModal
          show={setting.show}
          loading={setting.loading}
          onHide={() =>
            setSetting({ ...setting, show: false, loading: false })
          }
        />
      )}

      {/* Upload Modal */}
      {modal.show && (
        <ImageCrop
          show={modal.show}
          loading={modal.loading}
          onHide={() =>
            setModal({ ...modal, show: false, loading: false })
          }
        />
      )}
    </div>
  );
};

export default Index;